module.exports = __webpack_public_path__ + "static/media/removeOn.c646578d.svg";